var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"bigHeading"}},[_c('div',{staticClass:"heading"},[_c('span',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('markdown',{staticClass:"markdown"},[_vm._v("## "+_vm._s(_vm.data.heading))]),_vm._v(" "),(_vm.data.byline)?_c('span',{staticClass:"byline"},[_vm._v(_vm._s(_vm.data.byline))]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9d3f6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bigHeading.vue
// module id = VwZG
// module chunks = 1